//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import FileSelect from "@/components/admin/FileSelect";
import cloneDepp from 'lodash.clonedeep'
import isEqual from 'lodash.isequal'

const newInfo = {
  "title":"",
  "sub_headline":"",
  "brief_description":"",
  "post_content":"",
  "product_homepage":"",
  "contact":"",
  "phone":"",
  "email": "",
  "product_image":"",
  "image1_url":"",
  "image1_headline":"",
  "image1_excerpt":"",
  "image2_url":"",
  "image2_headline":"",
  "image2_excerpt":"",
  "image3_url":"",
  "image3_headline":"",
  "image3_excerpt":"",
  "image4_url":"",
  "image4_headline":"",
  "image4_excerpt":"",
  "video1_url":"",
  "video1_headline":"",
  "video1_excerpt":"",
  "video2_url":"",
  "video2_headline":"",
  "video2_excerpt":"",
  "video3_url":"",
  "video3_headline":"",
  "video3_excerpt":"",
  "file1_url":"",
  "file1_headline":"",
  "file1_excerpt":"",
  "file2_url":"",
  "file2_headline":"",
  "file2_excerpt":"",
  "tech_cloud": false,
  "tech_install": false,
  "tech_mobil": false,
  "tech_offline": false,
  "type": "",
  "hardware": false
}

export default {
  components: { FileSelect },
  name: "EditDialog",
  data() {
    return {
      info: {},
      infoOrig: {},
      loading: false,
      confirm: false,
      ticked: [],
      tickStrategy: 'leaf',
      showDialog: false,
      toolbar: [
        ['left', 'center', 'right', 'justify'],
        ['bold', 'italic', 'strike', 'underline'],
        ['unordered', 'ordered', 'outdent', 'indent', {
          label: this.$q.lang.editor.fontSize,
          icon: this.$q.iconSet.editor.fontSize,
          fixedLabel: true,
          fixedIcon: true,
          list: 'no-icons',
          options: [
            'size-1',
            'size-2',
            'size-3',
            'size-4',
            'size-5',
            'size-6',
            'size-7'
          ]
        }]
      ],
      selectedImage: null,
      screenshot: null,
      image: null,
      imageUrl: null,
      showSnackbar: false,
    }
  },
  methods: {
    ...mapActions(['updateManufacturerInfo']),
    onCancel() {
      console.log('Cancel')
      this.confirm = false
    },
    onConfirm(){
      console.log('Confirm')
      this.showDialog = false
      this.confirm = false
    },
    changed(){
       console.log("changed")
    },
    factoryFn () {
      return new Promise((resolve) => {
        resolve({
          url: 'http://localhost:8000/wp-json/s3m/v1/image_upload',
          method: 'POST',
          headers: [
            { name: 'Authorization', value: `Bearer ${ this.jwtToken }` }
          ]
        })
      })
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    imageSelected(image) {
      this.image = image
    },
    show(info) {
      if(typeof(info) !== 'undefined') {
        this.info = info
        this.ticked = [...info.processes]
      } else {
        this.info = { ...newInfo }
      }
      this.infoOrig = cloneDepp(info)
      this.showDialog = true
    },
    savePost() {
      this.info.processes = [...this.ticked ]
      if( typeof( this.info.id ) !== 'undefined' ) {
        this.$store.dispatch('updateManufacturerInfo', this.info).then(() => {
          this.showSnackbar = true

        })
      } else {
        this.$store.dispatch('createManufacturerInfo', this.info).then(() => {
          this.showSnackbar = true
        })
      }
      this.showDialog = false
    },
    discardPost() {
      if (!isEqual(this.infoOrig, this.info )) {
        this.confirm = true
      } else {
        this.showDialog = false
      }
    }
  },
  computed: {
    ...mapState(['processData', 'jwtToken']),
    processTree() {
      let processes  =  this.processData.map( process => { return { ...process } })
      let result = { name: "Gruppen", id: 0 }
      let idToProcess = processes.reduce((acc, process) => {
        acc[process.id] = process
        return acc
      }, {})
      processes.forEach(process => {
        const parent = process.parent === 0 ? result : idToProcess[process.parent]
        if( typeof(parent.children) === 'undefined' ) parent.children = []
        parent.children.push(process)
      })
      return [ result ]
    },
  },
  watch: {
    screenshot() {
       console.log("Changed")

    }
    }
}
